import { HistoryBulkEdit } from './BulkEditTypes';

export interface ImportFileStatistics {
  numberOfImportation: number;
  maxNumberOfUsers: number;
  numberImportEncour: number;
  lastImportationDate: string;
}

export interface ImportFileHistoryResponse {
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  visible: boolean;
  data: HistoryBulkEdit[];
}

export interface Search {
  value: string | null;
  regex: boolean;
}

export interface Order {
  column: string | null;
  dir: string | null;
  custom: boolean;
}

export interface ImportationUsersFilter {
  search: string | null;
  status: string | null;
  date_created_max: string | null;
  date_created_min: string | null;
  dateMax: string | null;
  dateMin: string | null;
  range_min: string | null;
  range_max: string | null;
}

export interface ImportationDataFilters {
  start: number;
  length: number;
  search: Search;
  order: Order[] | null;
  filters: ImportationUsersFilter;
}

export interface ImportFileCell {
  id: number;
  cellIndex: number;
  cellName: string;
  cellType: string;
  importationId: number;
}

export interface ImportSettingsResponse {
  id: number;
  cells: ImportFileCell[];
  columns: SelectItem[];
  cellsList: SelectItem[];
}

export interface ImportationDataListing {
  id: number;
  userName: string | null;
  firstName: string | null;
  lastName: string | null;
  connectWithPhoneNumber: boolean | null;
  connectWithPhoneNumberText: string | null;
  gender: string | null;
  phoneNumber: string | null;
  birthDate: string | null;
  nationality: string | null;
  nationalityName: string | null;
  emailperso: string | null;
  phoneNumberperso: string | null;
  adresse: string | null;
  ville: string | null;
  region: string | null;
  codePostal: string | null;
  country: string | null;
  countryName: string | null;
  matricule: string | null;
  hiringDate: string | null;
  typeOfContrat: string | null;
  typeOfContratName: string | null;
  cnss: string | null;
  endOfTrial: string | null;
  endDate: string | null;
  status: string | null;
  statusName: string | null;
  familyStatus: string | null;
  errorMessage: string | null;
  cin: string | null;
  soldInitial: string | null;
  salaire: number | null;
  salaryCurrency: string | null;
  userId: string | null;
  importationId: number | null;
  isUpdated: boolean | null;
  fonctionId: number | null;
  departementId: number | null;
  teamId: number | null;
  siteId: number | null;
  societyId: number | null;
  workTimeId: number | null;
  fk_RigimeCongee: number | null;
  fonctionName: string | null;
  departementName: string | null;
  teamName: string | null;
  siteName: string | null;
  societyName: string | null;
  workTimeName: string | null;
  timeoff_policies: string | null;
  supervisor: string | null;
  lang: string | null;
  langName: string | null;
  soldeReg: number | null;
  changedFields?: string[] | null;
  previousValues?: string[] | null;
}

export interface ImportationDataListingResponse {
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  visible: boolean;
  data: ImportationDataListing[];
}

export interface ProcessImportationResponse {
  result: object;
  id: number;
  exception: string | null;
  status: number;
  isCanceled: boolean;
  isCompleted: boolean;
  isCompletedSuccessfully: boolean;
  creationOptions: number;
  asyncState: object | null;
  isFaulted: boolean;
}

export enum ImportationStatuses {
  NotStarted = 0,
  Pending = 1,
  Initial = 2,
  InProgress = 3,
  Terminated = 4,
  Failed = 5,
  Invalid = 6,
}

export const getStatusFromNumber = (statusNumber: number): string => {
  return (
    Object.keys(ImportationStatuses).find(
      (key) =>
        ImportationStatuses[key as keyof typeof ImportationStatuses] ===
        statusNumber,
    ) || 'Invalid'
  );
};

export interface ImportationStatistics {
  id: number;
  closed: boolean;
  numberOfUsers: number;
  numberOfUsersToChange: number;
  numberOfUsersToCreate: number;
  numberOfUsersUnmatched: number;
  status: string | null;
  state: number;
  contracts: SelectItem[] | null;
  genres: SelectItem[] | null;
  nationalitys: SelectItem[] | null;
  fonctions: SelectItem[] | null;
  departements: SelectItem[] | null;
  teams: SelectItem[] | null;
  sites: SelectItem[] | null;
  societys: SelectItem[] | null;
  regimes: SelectItem[] | null;
  familyStatus: SelectItem[] | null;
  timeoff_policies: SelectItem[] | null;
  supervisors: SelectItem[] | null;
  languages: SelectItem[] | null;
  currencies: SelectItem[] | null;
}
